import type { FunctionComponent } from "react";
import type {
  ActionOutputData,
  RecordJobData,
} from "@smartsuite/automation-engine-api";
import { ActivityDetailsTriggerGroup } from "../ActivityDetailsTriggerGroup/ActivityDetailsTriggerGroup";
import { ActivityDetailsItem } from "../ActivityDetailsItem/ActivityDetailsItem";
import {
  addEmptyValueIfNeeded,
  findOutputValueStringWithLimit,
  getInputLabel,
} from "../../../ActivityGrid/ActivityGrid.helpers";
import type { AutomationsStore } from "../../../../../stores/automation/index.store";
import type { ActionCandidate } from "../../../../../types/candidate";
import * as S from "../GenerateWebhookGroup/style";
import { useGenerateWebhookGroup } from "../GenerateWebhookGroup/generate-webhook-group.hook";
import { useTranslation } from "react-i18next";

export const GeneralWebhookGroupWrapper: FunctionComponent<{
  index: number;
  jobDetails: any;
  onDetailsClickWithFetch?: (recordJodId: string) => Promise<void>;
  onDetailsClick?: () => void;
  recordJodId?: string;
  action: ActionOutputData;
  automations: AutomationsStore;
  selectedActionFallback: ActionCandidate | undefined;
  recordJob?: RecordJobData;
}> = ({
  index,
  jobDetails,
  recordJob,
  onDetailsClickWithFetch,
  onDetailsClick,
  recordJodId,
  action,
  automations,
  selectedActionFallback,
}) => {
  const { t } = useTranslation();

  const { getSortedInputs, getInputValue, getOutputDatas } =
    useGenerateWebhookGroup(jobDetails.job.automation?.timezone);

  return (
    <ActivityDetailsTriggerGroup
      title={`${t("general.inputs")}`}
      onClick={() => {
        if (
          recordJodId !== undefined &&
          onDetailsClickWithFetch !== undefined
        ) {
          void onDetailsClickWithFetch(recordJodId);
        }
        if (onDetailsClick !== undefined) {
          onDetailsClick();
        }
      }}
    >
      {recordJob &&
        getSortedInputs(recordJob).flatMap((input) => (
          <ActivityDetailsItem
            key={input.inputId}
            label={getInputLabel(
              input,
              jobDetails,
              action,
              automations.candidate.allActions,
              selectedActionFallback,
              index,
            )}
          >
            {addEmptyValueIfNeeded(getInputValue(input))}
          </ActivityDetailsItem>
        ))}
      <S.ResponseTitle>
        {t("automation.action-test-available-fields")}
      </S.ResponseTitle>
      {recordJob &&
        getOutputDatas(recordJob).map((output) => (
          <ActivityDetailsItem key={output.outputId} label={output.outputLabel}>
            {addEmptyValueIfNeeded(
              findOutputValueStringWithLimit(
                output.outputId,
                recordJob.outputData?.outputs ?? [],
              ),
            )}
          </ActivityDetailsItem>
        ))}
    </ActivityDetailsTriggerGroup>
  );
};
